import { NavController } from '@ionic/angular';
import { CacheService } from 'ionic-cache';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {
  constructor(private navCtrl: NavController, private cache: CacheService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.isLoggedIn().then(loggedIn => {
      if (!loggedIn) {
        const params = {
          brand: route.params['brand'],
          sku: route.params['sku']
        };

        this.navCtrl.navigateForward('/login', { queryParams: params });
      }
      return loggedIn;
    });
  }

  isLoggedIn(): Promise<boolean> {
    // Temp fix for 2.0 work. Log out anyone that has a token cached that was issued before August 22, 2022
    return this.cache
      .getItem('loginInfo')
      .then(
        res =>
          res.access_token &&
          new Date(res['.expires']) >= new Date() &&
          new Date(res['.issued']) >= new Date(2022, 7, 22)
      )
      .catch((error: any) => false);
  }
}
